import { SsmoTask, SsmoTaskStatus } from 'modules/onboarding-page/constants';
import { SsmoTaskStep } from 'modules/onboarding-page/types';

import { MenuPhotoShootOption } from '../../modules/self-serve-sign-up/SelfServeFormView/SelfServeSignUpForm/types';

export type ApiWeeklyScheduleEvent = {
  type: 'open' | 'close';
  value: number; // milliseconds
};

export type ApiWeeklySchedule = {
  monday: ApiWeeklyScheduleEvent[];
  tuesday: ApiWeeklyScheduleEvent[];
  wednesday: ApiWeeklyScheduleEvent[];
  thursday: ApiWeeklyScheduleEvent[];
  friday: ApiWeeklyScheduleEvent[];
  saturday: ApiWeeklyScheduleEvent[];
  sunday: ApiWeeklyScheduleEvent[];
};

export type User = {
  country: string | undefined;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string | undefined;
};

export type SigneeInformation = {
  country: Country;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  hasAlreadySignedUp: boolean;
};

export type UserContract = {
  signingUrl: string;
  merchantName: string;
};

export type OnboardingStatus = 'SSMO_ONBOARDING_PAGE' | 'LEGACY';
export type OnboardingStatusData = { status: OnboardingStatus; merchantId?: string; country: Country };

export const OPENING_HOURS_TYPES = ['normal', 'twenty-four-seven', 'complicated'] as const;

export type OpeningHoursType = (typeof OPENING_HOURS_TYPES)[number];

export const CLOSE_DELIVERIES_OPTIONS = [
  'at-closing',
  '30-minutes-before-closing',
  '60-minutes-before-closing',
] as const;

export type CloseDeliveries = (typeof CLOSE_DELIVERIES_OPTIONS)[number];

export type OpeningTimes = {
  type: OpeningHoursType;
  weeklySchedule: ApiWeeklySchedule;
};

export type DeliveryTimes = {
  type: CloseDeliveries;
  weeklySchedule: ApiWeeklySchedule;
};

export type DraftVenue = {
  id: string;
  merchantId: string;
  merchantName: string;
  name: string;
  address: string;
  website: string | null;
  postCode: string;
  city: string;
  country: string;
  status: 'BLANK' | 'READY_TO_SUBMIT' | 'SUBMITTED_FOR_REVIEW' | 'VENUE_CREATED';
  openingTimes: OpeningTimes | null;
  deliveryTimes: DeliveryTimes | null;
};

export type UpdateDraftVenueRequest = {
  name: string;
  address: string;
  website: string | null;
  postCode: string;
  city: string;
  country: string;
  status: 'BLANK' | 'READY_TO_SUBMIT';
  openingTimes: OpeningTimes;
  deliveryTimes: DeliveryTimes;
};

export type InboundMerchantVenueUpdateRequest = {
  name: string;
  address: string;
  postCode: string;
  city: string;
  productLine: string;
  openingTimes?: ApiWeeklySchedule;
};

export type SsmoMenuSource = 'FILE_UPLOAD' | 'MENU_LINK';

export type InboundMerchantUpdateRequest = {
  ssmoStepCompletionId?: string | null;
  name?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  email?: string;
  venues?: InboundMerchantVenueUpdateRequest[];
  website?: string;
  businessId?: string;
  country?: string;
  businessType?: string;
  language?: string;
  joinedToWoltPlus?: boolean;
  needsPrinter?: boolean;
  needsMobileDataPackage?: boolean;
  ssmoMenuFileLink?: string;
  address?: string;
  postCode?: string;
  city?: string;
  menuPhotoShootChoice?: MenuPhotoShootOption;
  ssmoMenuSource?: SsmoMenuSource;
};

export type Tasks = {
  [key in SsmoTask]: {
    status: SsmoTaskStatus;
    steps: SsmoTaskStep[];
  };
};

export type OnboardingProgressResponse = {
  tasks: Tasks;
};

export type OnboardingReviewInfo = {
  businessId: string;
  country: string;
  deliveryCommission: string;
  merchantAddress: string;
  merchantCity: string;
  merchantId: string;
  merchantName: string;
  merchantPostCode: string;
  photographFee: string;
  printerFee: string;
  simCardFee: string;
  subscriptionCommission: string;
  tabletFee: string;
  takeawayCommission: string;
  venueAddress: string;
  venueCity: string;
  venueName: string;
  venuePostCode: string;
};
